import { AirflowEnum, DamperBlades, DamperType, RoundDamperBlades, UserInput } from 'src/actuators/user-input/types.ts';
import { stringToEnum } from 'src/utils/stringToEnum.ts';
import { QueryParams } from 'src/actuators/user-input/calculations/constants.ts';

export const encodeInputState = (state: UserInput): string => JSON.stringify(
    Object.entries(state).sort(([a], [b]) => a.localeCompare(b))
        .map(([, v]) => v),
);

export function initInputState(search: URLSearchParams, initialState: UserInput): UserInput {
    const value = search.get(QueryParams.input);
    if (value) {
        try {
            const parsed = JSON.parse(value);
            return (Object.keys(initialState) as Array<keyof UserInput>)
                .sort((a, b) => a.localeCompare(b))
                .reduce((acc, name, currentIndex) => {
                    if (parsed[currentIndex] !== undefined && typeof parsed[currentIndex] !== 'object') {
                        if (name === 'damper') {
                            acc.damper = stringToEnum(DamperType, parsed[currentIndex]);
                        } else if (name === 'blade') {
                            acc.blade = stringToEnum(DamperBlades, parsed[currentIndex]);
                        } else if (name === 'air') {
                            acc.air = stringToEnum(AirflowEnum, parsed[currentIndex]);
                        } else if (name === 'roundDumper') {
                            acc.roundDumper = stringToEnum(RoundDamperBlades, parsed[currentIndex]);
                        } else {
                            acc[name] = parsed[currentIndex];
                        }
                    }
                    return acc;
                }, { ...initialState } as UserInput);
        } catch (e) {
            return { ...initialState };
        }
    }
    return { ...initialState };
}
